var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhoto(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 3,
    fill: "#F1F2F2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.6297 20.3295C19.5555 20.3295 21.1166 18.7685 21.1166 16.8426C21.1166 14.9168 19.5555 13.3558 17.6297 13.3558C15.7039 13.3558 14.1428 14.9168 14.1428 16.8426C14.145 18.7675 15.7049 20.3273 17.6297 20.3295ZM17.6297 14.3855C18.9866 14.3855 20.0865 15.4854 20.0865 16.8422C20.0865 18.1991 18.9866 19.299 17.6297 19.299C16.2729 19.299 15.1729 18.1991 15.1729 16.8422C15.1745 15.486 16.2735 14.3871 17.6297 14.3855Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4248 10.4702H10.5753C9.15365 10.4719 8.00161 11.6239 8 13.0455V26.9521C8.00161 28.3737 9.15365 29.5257 10.5753 29.5273H29.4248C30.8464 29.5257 31.9984 28.3737 32 26.9521V13.0455C31.9984 11.6239 30.8464 10.4719 29.4248 10.4702ZM10.5753 11.5004H29.4248C30.2776 11.5014 30.9689 12.1925 30.9699 13.0455V23.2L27.8882 18.8337C27.4102 18.1567 26.6356 17.7509 25.8069 17.7436C24.978 17.7364 24.1963 18.1283 23.7066 18.7971L20.199 23.5861C19.7107 24.2555 18.7806 24.4192 18.0931 23.9569L15.4707 22.2021C14.6094 21.6242 13.4854 21.6204 12.6202 22.1926L9.03031 24.5834V13.0455C9.03132 12.1927 9.72242 11.5014 10.5753 11.5004ZM29.4248 28.4972H10.5753C9.72222 28.4962 9.03112 27.8049 9.03011 26.9521V25.8214L13.1888 23.0519C13.7077 22.7093 14.3813 22.7119 14.8975 23.0582L17.5199 24.8132C18.6659 25.5837 20.2161 25.3105 21.0297 24.1947L24.5373 19.4057C24.8311 19.0043 25.3001 18.7691 25.7974 18.7735C26.2948 18.778 26.7595 19.0214 27.0462 19.4276L30.9695 24.9864V26.9521C30.9685 27.8049 30.2774 28.496 29.4248 28.4972Z",
    fill: "#58595B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoto);
export default __webpack_public_path__ + "static/media/photo.0007194944128fab6f67801c4b26da73.svg";
export { ForwardRef as ReactComponent };